// store/thunks/attachmentsThunks.js
import { createAsyncThunk } from '@reduxjs/toolkit';
import { client } from "../..";
import {
    CREATE_ATTACHEMNTS,
    GET_ALLATTACHMENTS_BY_ID,
    DELETE_ATTACHMENTS,
    UPDATE_ATTACHMENTS
} from '../../Queries/Orders';
import axios from 'axios';
import { SERVER_URL } from '../../databucket';

export const getAllAttachmentsByIDThunk = createAsyncThunk(
    'attachments/getAll',
    async (attachmentObj, { rejectWithValue }) => {
        try {
            const response = await client.mutate({
                mutation: GET_ALLATTACHMENTS_BY_ID,
                variables: attachmentObj,
                fetchPolicy: 'no-cache',
            });

            const data = response?.data?.getAllAttachmentsByID || [];
            const flatHistory = data.flatMap(item =>
                Array.isArray(item?.attachmentHistory) ? item.attachmentHistory : []
            );

            return { raw: data, flattened: flatHistory };
        } catch (err) {
            return rejectWithValue(err.message);
        }
    }
);

export const createAttachmentThunk = createAsyncThunk(
    'attachments/create',
    async ({ file, emailId, userId }, { rejectWithValue }) => {
        try {
            const formData = new FormData();
            formData.append('files', file);

            const res = await axios.post(`${SERVER_URL}/upload`, formData);
            const savedFile = res.data.files[0];

            const valuesObject = {
                userId,
                emailId,
                data: savedFile.url,
                filename: savedFile.originalName,
                mimetype: savedFile.mimeType,
                addDate: Date.now().toString(),
                updateDate: Date.now().toString(),
                status: true,
            };

            const response = await client.mutate({
                mutation: CREATE_ATTACHEMNTS,
                variables: valuesObject,
            });

            return response.data;
        } catch (err) {
            return rejectWithValue(err.message);
        }
    }
);

export const updateAttachmentThunk = createAsyncThunk(
    'attachments/update',
    async ({ file, attachmentId, userId }, { rejectWithValue }) => {
        try {
            const formData = new FormData();
            formData.append('files', file);

            const res = await axios.post(`${SERVER_URL}/upload`, formData);
            const savedFile = res.data.files[0];

            const valuesObject = {
                id: attachmentId,
                userId,
                data: savedFile.url,
                filename: savedFile.originalName,
                mimetype: savedFile.mimeType,
                updateDate: Date.now().toString(),
            };

            const response = await client.mutate({
                mutation: UPDATE_ATTACHMENTS,
                variables: valuesObject,
            });

            return response.data;
        } catch (err) {
            return rejectWithValue(err.message);
        }
    }
);

export const deleteAttachmentThunk = createAsyncThunk(
    'attachments/delete',
    async ({ id, userId }, { rejectWithValue }) => {
        try {
            const valuesObject = {
                id,
                userId: userId.toString(),
                updateDate: Date.now().toString(),
            };

            const response = await client.mutate({
                mutation: DELETE_ATTACHMENTS,
                variables: valuesObject,
            });

            return response.data;
        } catch (err) {
            return rejectWithValue(err.message);
        }
    }
);

export const multipleAttachmentsThunk = createAsyncThunk(
  'attachments/uploadAndCreate',
  async ({ files, userId, emailId }, thunkAPI) => {
    try {
      const formData = new FormData();
      files.forEach((file) => {
        formData.append('files', file);
      });

      const uploadResponse = await axios.post(`${SERVER_URL}/upload`, formData);
      const uploadedFiles = uploadResponse.data.files;

      for (const uploadedItem of uploadedFiles) {
        const valuesObject = {
          userId,
          emailId,
          data: uploadedItem.url,
          filename: uploadedItem.originalName,
          mimetype: uploadedItem.mimeType,
          addDate: Date.now().toString(),
          updateDate: Date.now().toString(),
          status: true,
        };

        await client.mutate({
          mutation: CREATE_ATTACHEMNTS,
          variables: valuesObject,
        });
      }

      return uploadedFiles; // optional: return to use in UI
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response?.data || error.message);
    }
  }
);